//  电话长度最大 9 位数
export const validatePhoneLength = (str, len) => str.length <= len;

//  是否是数字
export const isNumber = data => /^-?[0-9]+\.?[0-9]{0,}$/.test(String(data));

//  是否是合法 IP
export const ipValidate = data => /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(data);

//  按长度判断是否是数字和字母
export const isNumberOrLetter = (data = '', min = 1, max = 200) => /^[0-9a-zA-Z]+$/.test(data) && (data?.length ?? 0) >= min && (data?.length ?? 0) <= max;
